module.exports = __webpack_public_path__ + "static/media/cepheus_logo.8a736fa5.jpeg";